import RouteIndex from "@/views/directory/route/RouteIndex.vue";

const destination = [
    {
        path: '/routes',
        name: 'routes',
        component: RouteIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default destination;